import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MEMBERSHIP_QUESTIONS } from "rtr-constants";
import MembershipHelpers from "helpers/membership-helpers";

const initialState = {
  customerPromise: {
    isEligible: null,
    loaded: false,
    error: null,
  },
};

export const fetchCustomerPromiseEligibility = createAsyncThunk(
  "customerPromise/fetchEligibility",
  async ({ membershipState, userData }) => {
    try {
      const isEligible = await MembershipHelpers.fetchSingleMembershipAnswer(
        MEMBERSHIP_QUESTIONS.IS_CUSTOMER_PROMISE_ELIGIBLE,
        membershipState,
        userData
      );
      return isEligible;
    } catch (e) {
      return Promise.reject("Failed to check eligibility");
    }
  }
);

export const customerPromiseSlice = createSlice({
  name: "customerPromise",
  initialState,
  extraReducers: builder => {
    builder.addCase(fetchCustomerPromiseEligibility.fulfilled, (state, action) => {
      state.customerPromise = {
        isEligible: action.payload,
        loaded: true,
        error: null,
      };
    });
    builder.addCase(fetchCustomerPromiseEligibility.rejected, (state, action) => {
      state.customerPromise = {
        isEligible: null,
        loaded: true,
        error: action.error?.message,
      };
    });
  },
});

export default {
  types: ["customerPromise/fetchEligibility/fulfilled", "customerPromise/fetchEligibility/rejected"],
  fn: customerPromiseSlice.reducer,
};
